import "./simple-loader.scss";

const SimpleLoader = ({ height = "10px", width = "10px", color = "#3498db" }) => {
  return <div className="simple-loader" style={{ height, width, borderTopColor: color }}></div>;
};

export default SimpleLoader;
